import React, { Dispatch, FC } from 'react';
import { Row, TablePropGetter, TableProps } from 'react-table';

import { fc } from 'i18n';
import { TableRow } from './table-row';

import styles from './styles.module.css';

import { PreloaderStyled } from 'ui/atoms/preloader.styled';
import { PreloaderWrapperStyled, TableContentStubStyled, TableNotContentFound } from 'ui/table.styled';

interface ITableContent {
  isLoading: boolean;
  clickedRowId?: string;
  data: Record<string, unknown>[] | null;
  rows: Row<Record<string, unknown>>[];
  selectedRowIds?: string[];
  prepareRow: Dispatch<Row<Record<string, unknown>>>;
  getTableBodyProps: (propGetter?: TablePropGetter<Record<string, unknown>>) => TableProps;
  onRowClick?: Dispatch<any>;
}

export const TableContent: FC<ITableContent> = (props) => {
  const { isLoading, data, rows, prepareRow, getTableBodyProps, ...rest } = props;

  if (isLoading) {
    return (
      <>
        <PreloaderWrapperStyled>
          <PreloaderStyled />
        </PreloaderWrapperStyled>
        <TableContentStubStyled>
          {rows.map((row, index) => {
            prepareRow(row);

            return <TableRow key={index} index={index} row={row} />;
          })}
        </TableContentStubStyled>
      </>
    );
  }

  if (!isLoading && !data?.length) {
    return (
      <TableContentStubStyled>
        <TableNotContentFound>
          <span>{fc('no content found')}</span>
        </TableNotContentFound>
      </TableContentStubStyled>
    );
  }

  if (data) {
    return (
      <div {...getTableBodyProps()} className={styles.body}>
        {rows.map((row, index) => {
          prepareRow(row);

          return <TableRow key={index} index={index} row={row} {...rest} />;
        })}
      </div>
    );
  }

  return null;
};
